import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IAttendee } from '../../../../Models/Attendees/IAttendee';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { FindAttendeeView } from './FindAttendeeView';
import * as Services from '../../../../Services/Services';
import { IAdminApi } from '../../../../Services/API/Admin/IAdminApi';
import { MessageBarType, Panel, PanelType, Stack, TextField } from '@fluentui/react';
import { AttendeePropertiesAdmin } from '../AttendeeProperties/AttendeePropertiesAdmin';
import UserProperties from '../UserProperties/UserProperties';
import {getAge} from "../../../../Tools/DateTime";

interface IFindAttendeeProps {

}


export const FindAttendee: React.FunctionComponent<IFindAttendeeProps> = (props) => {

    const [loadedAttendeeList, setLoadedAttendeeList] = React.useState<IAttendee[]>([]);
    const [attendeeList, setAttendeeList] = React.useState<IAttendee[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [name, setName] = React.useState<string>("")
    const [selectedAttendee, setSelectedAttendee] = React.useState<IAttendee>();
    const [selectedUserId, setSelectedUserId] = React.useState<string>()

    const [order, setOrder] = React.useState<{ columnKey: string | null, isAsc: boolean }>({ columnKey: null, isAsc: true });

    const [showUserProperties, setShowUserProperties] = useBoolean(false);
    const [showAttendeeProperties, setShowAttendeeProperties] = useBoolean(false);
    
    const [minAge, setMinAge] = React.useState<number | null>(null);
    const [maxAge, setMaxAge] = React.useState<number | null>(null);

    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const adminUserApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
        const eventType = await adminUserApi.findAttendees(name);

        if (eventType.isSuccess) {
            if (eventType.data && eventType.data.length > 0) {
                setStatusMessage({ message: eventType.message, type: MessageBarType.success });
                setAttendeeList(eventType.data);
                setLoadedAttendeeList(eventType.data);
            }
            else {
                setStatusMessage({ message: "Nebyli nalezeni žádní žáci.", type: MessageBarType.warning });
            }
        }
        else {
            setStatusMessage({ message: eventType.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const orderData = (filteredList: IAttendee[]) => {
        if (!order.columnKey) {
            return;
        }

        const sorted = [...filteredList].sort((a, b) => {
            let key = order.columnKey as keyof IAttendee;
            
            if (order.columnKey === "age") {
                key = "dateOfBirth" as keyof IAttendee;
            }

            const valueA = a[key];
            const valueB = b[key];

            // Handle undefined or null values
            if (valueA == null) return 1;
            if (valueB == null) return -1;

            if (order.isAsc) {
                return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
            } else {
                return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
            }
        });

        setAttendeeList(sorted);
    }
    
    const filterData = () => {
        let filtered = loadedAttendeeList.filter(x => {
            let result = true;
            if (minAge) {
                result = result && getAge(x.dateOfBirth) >= minAge;
            }
            if (maxAge) {
                result = result && getAge(x.dateOfBirth) <= maxAge;
            }
            return result;
        });

        if (!order.columnKey) {
            setAttendeeList(filtered);
        } else {
            orderData(filtered);
        }
    }

    const exportToCsv = () => {
        let csvContent = "\uFEFF Jméno;Příjmení;Email;Telefon;Ulice;Město;\n";

        attendeeList.forEach((item) => {

            let row = `${item.firstName};${item.lastName};${item.email};${item.phoneNumber};${item.street};${item.city};`;
            csvContent = csvContent + row + "\n";
        });
        var link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([csvContent], {
            type: "data:text/csv;charset=utf-8"
        }));
        link.setAttribute("href", url);
        link.setAttribute("download", "seznamUcastniku.csv");
        document.body.appendChild(link); // Required for FF
        link.click();
        link.remove();
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        loadData();
    }, [name])
    
    React.useEffect(() => {
        filterData();
    }, [order])
    
    React.useEffect(() => {
        filterData();
    }, [minAge, maxAge])

    return (
        <Stack styles={{ root: { paddingLeft: 20, paddingRight: 20 } }}>
            <FindAttendeeView isLoading={isLoading}
                items={attendeeList}
                selectItem={(item) => {
                    setSelectedAttendee(item);
                    setShowAttendeeProperties.setTrue();
                }}
                selectUserId={(userId) => {
                    setSelectedUserId(userId)
                    setShowUserProperties.setTrue();
                }
                }
                statusMessage={statusMessage}
                setFilter={setName}
                setMinAge={setMinAge}
                setMaxAge={setMaxAge}
                order={order}
                setOrder={setOrder}
                exportToCsv={exportToCsv}
            />

            {selectedAttendee ?
                <AttendeePropertiesAdmin
                    item={selectedAttendee}
                    isOpen={showAttendeeProperties}
                    close={setShowAttendeeProperties.setFalse} refresh={() => loadData()}                   
                />
                : null}

            {showUserProperties && selectedUserId ?
                <Panel
                    isOpen={showUserProperties}
                    onDismiss={setShowUserProperties.setFalse}
                    type={PanelType.medium}
                    closeButtonAriaLabel="Zavřít">
                    <UserProperties userId={selectedUserId} refresh={() => loadData()}/>
                </Panel> : null}


        </Stack>)
}
